/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { AboutVirdioPage } from "../pages/AboutVirdio";
import { HomeScreen } from "./HomeScreen"
import { AskMyraPage } from "../pages/AskMyra";
import { HowItWorksPage } from "../pages/HowItWorks";
function AppRoutesInner() {
    return (
        <>
            <Switch>
                <Route path="/" exact component={HomeScreen} />
                <Route path="/ask-myra" component={AskMyraPage} />
                <Route path="/how-it-works" component={HowItWorksPage} />
                <Route path="/about" component={AboutVirdioPage} />
            </Switch>
        </>
    );
}
export default function AppRoutesV2() {
    return (
        <Router>
            <AppRoutesInner />
        </Router>
    );
}
